import { render, staticRenderFns } from "./RegulatoryOrganization.vue?vue&type=template&id=67cb2228&scoped=true&"
import script from "./RegulatoryOrganization.vue?vue&type=script&lang=js&"
export * from "./RegulatoryOrganization.vue?vue&type=script&lang=js&"
import style0 from "./RegulatoryOrganization.vue?vue&type=style&index=0&id=67cb2228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cb2228",
  null
  
)

export default component.exports